export default __webpack_public_path__ + "static/media/Royal War Steed.458a0b9e.jpg";